import React, { useState } from 'react';
import { Button } from './ui/button';
import { Phone, Menu, X, MapPin } from 'lucide-react';
import { shopInfo, shopLogo } from '../data/mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Brands', href: '#brands' },
    { name: 'Products', href: '#products' },
    { name: 'Services', href: '#services' },
    { name: 'About', href: '#about' },
    { name: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-lg overflow-hidden bg-white shadow-sm">
              <img 
                src={shopLogo} 
                alt={shopInfo.name}
                className="w-full h-full object-contain"
              />
            </div>
            <div className="hidden sm:block">
              <h1 className="text-lg font-bold text-[#1e1919]">{shopInfo.name}</h1>
              <p className="text-xs text-[#736c64]">IT Solutions & Support</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => scrollToSection(link.href)}
                className="text-sm font-medium text-[#736c64] hover:text-[#61525a] transition-colors duration-200"
              >
                {link.name}
              </button>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <Button
              variant="outline"
              size="sm"
              className="border-[#2563eb] text-[#2563eb] hover:bg-[#2563eb] hover:text-white transition-colors duration-200"
              onClick={() => scrollToSection('#contact')}
            >
              <MapPin className="w-4 h-4 mr-1" />
              Visit Store
            </Button>
            <Button
              size="sm"
              className="bg-[#2563eb] hover:bg-[#1d4ed8] text-white transition-colors duration-200"
              onClick={() => window.open(`tel:${shopInfo.phone}`, '_self')}
            >
              <Phone className="w-4 h-4 mr-1" />
              Call Now
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-[#1e1919]"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-100">
            <nav className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <button
                  key={link.name}
                  onClick={() => scrollToSection(link.href)}
                  className="text-left py-2 px-4 text-[#736c64] hover:text-[#2563eb] hover:bg-[#f7f5f2] rounded-lg transition-colors duration-200"
                >
                  {link.name}
                </button>
              ))}
              <div className="flex flex-col gap-2 mt-4 px-4">
                <Button
                  className="bg-[#2563eb] hover:bg-[#1d4ed8] text-white w-full"
                  onClick={() => window.open(`tel:${shopInfo.phone}`, '_self')}
                >
                  <Phone className="w-4 h-4 mr-2" />
                  Call Now
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;